import React from 'react';
import { Link } from 'react-router-dom';
import GuidePageLayout from '../../components/seo/GuidePageLayout';

const FREE_TRIAL_URL = 'https://buy.stripe.com/5kA6rt11z6Dw06YbII';

export default function WhoItsFor() {
  return (
    <GuidePageLayout currentPath="/who-its-for">
      <h1>Who Horse Racing Oracle is for</h1>
      <p>
        Horse Racing Oracle is aimed at adults in the UK who already use (or intend to use) <strong>Betfair</strong> for{' '}
        <strong>UK horse racing</strong>, want <strong>rule-based automation</strong>, and understand that betting can
        result in losses. It is not a way to solve financial difficulties and not a substitute for professional advice.
      </p>

      <h2>Who may get value</h2>
      <ul>
        <li>You want consistent application of a defined approach rather than discretionary picks each day.</li>
        <li>You are comfortable authorising an app to place bets within limits you configure.</li>
        <li>You will read the <Link to="/terms-conditions">terms</Link>, <Link to="/privacy-policy">privacy policy</Link>
          , and <Link to="/refund-policy">refund policy</Link> before subscribing.</li>
      </ul>

      <h2>Who should not use it</h2>
      <ul>
        <li>Anyone under 18, or where automated betting is not legal for you.</li>
        <li>Anyone seeking guaranteed income or &quot;risk-free&quot; returns—those outcomes do not exist in betting.</li>
        <li>Anyone who cannot afford to lose the money they stake.</li>
      </ul>

      <h2>What you should read next</h2>
      <ul>
        <li>
          <Link to="/how-it-works">How it works</Link> — automation, UK focus, and risk framing.
        </li>
        <li>
          <Link to="/betfair-connection-and-security">Betfair connection &amp; security</Link> — access and expectations.
        </li>
        <li>
          <Link to="/staking-and-risk-controls">Staking &amp; risk controls</Link> — limits and staking modes.
        </li>
        <li>
          <Link to="/faqs">FAQs</Link> — short answers to common questions.
        </li>
      </ul>

      <p>
        Questions? <Link to="/contact">Contact us</Link>. Ready to evaluate the product?{' '}
        <a href={FREE_TRIAL_URL} rel="noopener noreferrer">
          Start a free trial
        </a>{' '}
        or return to the <Link to="/">homepage</Link>.
      </p>

      <div className="guideCta">
        <p className="guideCtaTitle">Evaluate with a trial</p>
        <a
          className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-gradient-to-r from-primary-200 via-primary-100 to-primary-200 hover:from-primary-100 hover:to-primary-100 transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5"
          href={FREE_TRIAL_URL}
          rel="noopener noreferrer"
        >
          Free trial
          <svg className="ml-2 -mr-1 w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </a>
      </div>
    </GuidePageLayout>
  );
}
